module.exports = __webpack_public_path__ + "media/images/lb/395-5688119282abf4eebc83563b91115c66.svg";